/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".password-error-details[_ngcontent-%COMP%]{display:block;margin:6px 0 12px;font-size:12px;line-height:1.4;color:#e31c23;text-align:left}.password-error-details[_ngcontent-%COMP%] > div[_ngcontent-%COMP%] + div[_ngcontent-%COMP%]{margin-top:4px}"];
export { styles as styles };
